module.exports = require("@ethereumjs/trie");